export const UsersActionTypes = {
  FETCH_ALL_USERS_START: "FETCH_ALL_USERS_START_NEW",
  FETCH_ALL_USERS_SUCCESS: "FETCH_ALL_USERS_SUCCESS_NEW",
  FETCH_ALL_USERS_FAILURE: "FETCH_ALL_USERS_FAILURE_NEW",
  FETCH_USERS_START: "FETCH_USERS_START_NEW",
  FETCH_USERS_SUCCESS: "FETCH_USERS_SUCCESS_NEW",
  FETCH_USERS_FAILURE: "FETCH_USERS_FAILURE_NEW",

  SET_USERS_ON_PAGE: "SET_USERS_ON_PAGE_NEW",
  SET_SEARCH_QUERY_USERS: "SET_SEARCH_QUERY_USERS_NEW",

  ADD_SELECTED_USER: "ADD_SELECTED_USER_NEW",
  DELETE_SELECTED_USER: "DELETE_SELECTED_USER_NEW",
  SET_SELECTED_USER: "SET_SELECTED_USER_NEW",

  SET_ADMIN_TAB: "SET_ADMIN_TAB_NEW",
};
